import { Injectable } from '@angular/core';
import { CanActivate, Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment, Route } from '@angular/router';
import { ClaimService } from './claim.service';

@Injectable({
  providedIn: 'root'
})
export class ClaimGuardService implements CanActivate, CanActivateChild {

  constructor(private claimService: ClaimService) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivateStep(route.data.step);
  }

  canActivateStep(step: number): boolean {
    const result = this.claimService.claimStep >= step;
    if (result) {
      this.claimService.claimStep = step;
    }

    return result;
  }

}
